import { SearchIndexCourseFilters } from '@shared/types';
import withPrefix from '../../strings/withPrefix';

export const PREFIX = 'delivered-';

const deliveryPath = (slug: NonNullable<SearchIndexCourseFilters['delivery']>): string => {
    return withPrefix(PREFIX, slug);
};

export default deliveryPath;
